import {
	SET_TRX_REDUCTION_FORM_STATE,
} from '../actions/TrxReductionActions.js';

// The two ways of giving the site ids to the process.
export const INPUT_MODE_TEXT = 'text';
export const INPUT_MODE_FILE = 'file';

const initialState = {
	formState: {
		trxReduction: {
			isValid: false,
			values: {
				inputMode: INPUT_MODE_TEXT,
				siteIdsText: '',
				siteIdsFile: null,
				planName: '',
			},
			touched: {},
			errors: {},
		}
	},
};

const trxReductionReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_TRX_REDUCTION_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default trxReductionReducer;
